import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import {Observable} from 'rxjs';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { CommandFailedAction, DoNothingAction } from '@shared/store/actions/particle.actions';
import {StreamsService} from '../../services/streams.service';
import {
  ADD_STREAMS, AddStreamsAction, DELETE_STREAMS, DeleteStreamsAction, GET_STREAMS, GetStreamsFailAction,
  GetStreamsSuccessAction
} from '../actions/streams.actions';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model'; // Build purpose
@Injectable()
export class StreamsEffects {
  constructor (
    private actions$: Actions,
    private streamsService: StreamsService,
    private commandService: CommandService,
    private snackBarService: SnackBarService,
    private fuseSplashScreenService: FuseSplashScreenService
  ) {}


  getStreams = createEffect(() => this.actions$.pipe(
    ofType(GET_STREAMS),
    mergeMap((action) => {
      this.fuseSplashScreenService.show();
      return this.streamsService.getStreams().pipe(
        map((payload: PaymentStreamSetting[]) => {
          this.fuseSplashScreenService.hide();
          return new GetStreamsSuccessAction(payload);
        }),
        catchError((error) => {
          this.fuseSplashScreenService.hide();
          return of (new DoNothingAction());
        })
      );
    })
  ));


  addStreams = createEffect(() => this.actions$.pipe(
    ofType(ADD_STREAMS),
    mergeMap((action: AddStreamsAction) => {
      this.fuseSplashScreenService.show();
      return this.commandService.executeCommand(action.command).pipe(
        switchMap(addStreamsNotification => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showInformation('Streams added');
          return of(new DoNothingAction());
        }),
        catchError(error => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Some error occurred');
          return of(new CommandFailedAction(error));
        })
      );
    })
  ));


  deleteStreams = createEffect(() => this.actions$.pipe(
    ofType(DELETE_STREAMS),
    mergeMap((action: DeleteStreamsAction) => {
      this.fuseSplashScreenService.show();
      return this.commandService.executeCommand(action.command).pipe(
        switchMap(deleteStreamsNotification => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showInformation('Streams deleted');
          return of(new DoNothingAction());
        }),
        catchError(error => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Some error occurred');
          return of(new CommandFailedAction(error));
        })
      );
    })
  ));
}
